/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    WineProductInstanceExpertRatingDto,
    WineRatingSystemInfoDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class WineRatingControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        addWineProductInstanceRating(
                    
                    
                    requestBody: WineProductInstanceExpertRatingDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/winerating/ratings`;

            return this._httpClient.post<number>(url, requestBody, requestOptions);
    }


        getAllowedRatingSystems(
                    instanceid: number
    ): Observable<{ [key: string]: string; }> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/winerating/ratings/productinstances/${instanceid}/allowed`;

            return this._httpClient.get<{ [key: string]: string; }>(url, requestOptions);
    }


        getWineProductInstanceRatings(
                    instanceid: number
    ): Observable<Array<WineProductInstanceExpertRatingDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/winerating/ratings/productinstances/${instanceid}`;

            return this._httpClient.get<Array<WineProductInstanceExpertRatingDto>>(url, requestOptions);
    }


        getWineRatingSystem(
                    id: string
    ): Observable<WineRatingSystemInfoDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/winerating/experts/systems/${id}`;

            return this._httpClient.get<WineRatingSystemInfoDto>(url, requestOptions);
    }


        getWineRatingSystems(
    ): Observable<Array<WineRatingSystemInfoDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/winerating/experts/systems`;

            return this._httpClient.get<Array<WineRatingSystemInfoDto>>(url, requestOptions);
    }


}

